type TenantErrorProps = {
  message?: string;
};

export function TenantError({ message }: TenantErrorProps) {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="mx-auto flex w-full max-w-md flex-col justify-center px-6 py-12">
        <div className="rounded-2xl bg-white p-8 shadow-sm ring-1 ring-gray-200">
          <div className="mb-8">
            <h1 className="text-2xl font-semibold text-gray-900">{'Error Loading Application'}</h1>
            <p className="mt-2 text-sm text-gray-600">{message || 'An unknown error occurred'}</p>
          </div>
          <button
            onClick={handleRetry}
            className="flex w-full items-center justify-center rounded-lg bg-gray-900 px-3 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-gray-800"
          >
            {'Retry'}
          </button>
        </div>
      </div>
    </div>
  );
}
